import {} from '../../constants/events';

const initialState = {
  companies: [],
  page: 1,
  totalCount: 0
};

const CompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_COMPANY':
      state = Object.assign({}, state, action.payload);
  }
  return state;
};

export default CompanyReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/CompanyReducer/index.js